import { Select } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface QuoteTypeSelectorProps {
  value: string | null | undefined
  onChange: (value: string) => void
  label?: string
  error?: string
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const QUOTE_TYPE_OPTIONS = ['product', 'time_and_materials']

const translateQuoteType = (quoteType: string): string => {
  switch (quoteType) {
    case 'product':
      return i18n.t('finance.quotes.quote_type.product')
    case 'time_and_materials':
      return i18n.t('finance.quotes.quote_type.time_and_materials')
    default:
      return ''
  }
}

function isValidQuoteType(value: string): value is string {
  return QUOTE_TYPE_OPTIONS.includes(value)
}

export const QuoteTypeSelector = ({
  value,
  onChange,
  label,
  error,
  disabled,
  size = 'md',
}: QuoteTypeSelectorProps) => {
  const options = QUOTE_TYPE_OPTIONS.map((quoteType) => ({
    label: translateQuoteType(quoteType),
    value: quoteType,
  }))

  return (
    <Select
      size={size}
      label={label}
      options={options}
      value={value ?? undefined}
      onChange={(newValue: string) => {
        if (newValue && isValidQuoteType(newValue)) {
          onChange(newValue)
        }
      }}
      error={error}
      disabled={disabled}
    />
  )
}
